// extracted by mini-css-extract-plugin
module.exports = {"content":"content___3a4Iy","container":"container___KcQzr","title":"title___24AYR","logoContainer":"logoContainer___Aa6w-"};